export default __webpack_public_path__ + "static/media/dummy_user.a834c7a1.svg";